import { objectDuckCreator } from '@atc/modular-redux';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

const vdpContentDuck = objectDuckCreator({
    ...vdpDuckPreset,
    store: 'content',
});

export default vdpContentDuck;
